import * as React from 'react';
import './Box.css';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import * as Service from '../../Services/service'
export default function CustomListPolicyCustomer({ policy, index }) {
    const navigation = useNavigate();
    // const frequency = policy.frequency !== undefined && policy.frequency !== null ?
    //     (policy.frequency === 'Yearly' ?
    //         "Hằng năm" : policy.frequency === "Monthly" ?
    //             "Hằng tháng" : policy.frequency === "Quarterly" ?
    //                 "Hằng quý" : policy.frequency === "Half-Yearly" ?
    //                     "Nửa năm" : "") : "";
    return (
        <div style={{ display: "flex" }}>
            <div className='index-box-list description-small-customer'>{index < 10 ? "0" + index : index}</div>
            <div className="box-list" style={{ backgroundColor: "#FFEDB1" }}>
                {/* Header */}
                <div className="header-list-policy">
                    <div className="col-md-5 non-padding description-large-customer">{t("customerpolicynumber") + policy.poNumber}</div>
                    <div className="col-md-4 non-padding status-customer">
                        <label style={{ backgroundColor: policy.policyStatus === 'Hiệu lực' || policy.policyStatus === 'Hiệu Lực' ? "green" : "gray" }}>
                            {policy.policyStatus}
                        </label>
                    </div>
                    <div className="col-md-3 non-padding col-end description-small-customer">
                        <a onClick={() => {
                            navigation("/hop-dong-bao-hiem/" + policy.poNumber, { state: { poNumber: policy.poNumber } });
                        }} style={{ color: "darkblue" }}>{t("pressdetail")}</a>
                    </div>
                </div>
                {/* Body */}
                {/* <div className="container-body-list"> */}
                <div className='table-policy-component'>
                    <table className='customer-policy-info-table' style={{ width: "100%" }}>
                        <thead>
                            <tr>
                                <th className='th-list-policy title description-small-customer th-other' style={{ textAlign: 'center' }}>{t("mainproduct")}</th>
                                <th className='th-list-policy title description-small-customer th-other' style={{ textAlign: 'center' }}>{t("datevalid")}</th>
                                <th className='th-list-policy title description-small-customer th-other' style={{ textAlign: 'center' }}>{t("policypaidToDate")}</th>
                                <th className='th-list-policy title description-small-customer th-other' style={{ textAlign: 'center' }}>{t("periodicinsurancepremium")}</th>
                                <th className='th-list-policy title description-small-customer th-other' style={{ textAlign: 'center' }}>{t("productfrequence")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className='td-list-policy descript description-small-customer' style={{ color: "#C3972D", textAlign: 'center' }}>{policy.componentName}</td>
                                <td className='td-list-policy descript description-small-customer' style={{ textAlign: 'center' }}>{policy.componentRcd}</td>
                                <td className='td-list-policy descript description-small-customer' style={{ textAlign: 'center' }}>{policy.paidToDate}</td>
                                <td className='td-list-policy descript description-small-customer' style={{ textAlign: 'center' }}>{policy.premium !== undefined && policy.premium !== null && policy.premium !== 0 ? Service.moneyFormat(policy.premium) : ""}</td>
                                <td className='td-list-policy descript description-small-customer' style={{ textAlign: 'center' }}>{policy.frequency}</td>
                            </tr>
                        </tbody>
                    </table>
                    {/* </div> */}
                </div>
            </div>
        </div>
    );
} 